export default "__VITE_ASSET__241e8017__"